import { get } from 'lodash';

export const getSiteInfo = state => get(state, 'siteInfo', {});
export const getPageTitle = state => getSiteInfo(state).pageTitle;
export const getSiteDescription = state => getSiteInfo(state).siteDescription;
